import React, { useEffect, useState } from "react";
import styles from "../Dashoard.module.css";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import EmptyCard from "../../EmptyCard/EmptyCard";
import { InfoIcon } from "../../../assets/icons/InfoIcon";

const Courses = (props) => {
  const { maxPriceSoldCourses, setHasCourses } = props;

  const [CoursesData, setCourseData] = useState([]);

  useEffect(() => {
    let newCourseData = [];

    if (maxPriceSoldCourses?.length > 0 && maxPriceSoldCourses) {
      maxPriceSoldCourses?.map((singlePriceSold, i) => {
        if (i <= 2) {
          newCourseData.push({
            label: singlePriceSold?.courseTitle,
            amount:
              singlePriceSold?.total_price === null
                ? "Free"
                : `$${singlePriceSold?.total_price}`,
          });
        }
      });

      setCourseData(newCourseData);
      setHasCourses(true);
    } else {
      setHasCourses(null);
      setCourseData([]);
    }
  }, [maxPriceSoldCourses]);

  return (
    <div
      className={styles.StatusSection}
      style={{
        height: "130px",
      }}
    >
      <div className={styles.StatusSectionHeader}>
        <h2>Courses </h2>
      </div>

      {CoursesData?.map((item, i) => (
        <div className={styles.StatusTableListing}>
          <div className={styles.StatusTableListingLabel}>{item.label}</div>
          <div className={styles.StatusTableListingEntry}>
            {item.upstatus && (
              <div className={styles.StatusCardChip}>
                <span className={styles.StatusCardChipGreen}>
                  <ArrowUpwardIcon />
                </span>
              </div>
            )}

            {item.downstatus && (
              <div className={styles.StatusCardChip}>
                <span className={styles.StatusCardChipRed}>
                  <ArrowDownwardIcon />
                </span>
              </div>
            )}
            {item.amount}
          </div>
        </div>
      ))}

      {CoursesData?.length == 0 && (
        <EmptyCard
          Icon={<InfoIcon />}
          description="You do not have any recent courses."
          showButton={false}
          BorderStatus="none"
          Padding="0px"
        />
      )}
    </div>
  );
};

export default Courses;
